/**
 * ⚠️ WARNING: DO NOT MODIFY THIS FILE DIRECTLY ⚠️
 *
 * This file is auto-generated from permissions/resource-servers.yaml
 * To make changes to permissions or resource servers:
 * 1. Edit permissions/resource-servers.yaml
 * 2. Run 'yarn generate:permissions'
 *
 * Any direct modifications to this file will be overwritten.
 */
// Source hash: 671cc3ca
// Last generated: 2026-10-26T16:15:57.789Z
/**
 * Resource server identifiers
 */
export const RESOURCE_SERVERS = {
    WEVO_ACCESS_API: {
        identifier: 'https://${var.api_url}/api',
        name: 'Wevo Access API - ${var.environment}',
        description: 'Wevo Access API for user and access management',
    },
    CUSTOMER_API: {
        identifier: 'https://customer.api.localwevoconversion.com/',
        name: 'Customer API - ${var.environment}',
        description: 'Customer API for Local WEVO Conversion',
    },
    ARTEMIS_API: {
        identifier: '${local.artemis_api_id}',
        name: 'Artemis API - ${var.environment}',
        description: 'Artemis API for advanced analytics and insights',
    },
    WEVO_PERSONA_API: {
        identifier: 'wevo-persona-api',
        name: 'wevo-persona-api',
        description: 'WEVO Persona API for Pulse sandbox access',
    },
};
/**
 * Permissions grouped by resource server
 */
export const PERMISSIONS = {
    WEVO_ACCESS_API: {
        'administrate:organizations': 'wevo_access_api:administrate:organizations',
        'administrate:users': 'wevo_access_api:administrate:users',
        'read:users': 'wevo_access_api:read:users',
        'manage:users': 'wevo_access_api:manage:users',
        'manage:teams': 'wevo_access_api:manage:teams',
        'manage:team_members': 'wevo_access_api:manage:team_members',
        'execute:sync_operations': 'wevo_access_api:execute:sync_operations',
        'manage:sows': 'wevo_access_api:manage:sows',
        'read:sows': 'wevo_access_api:read:sows',
        'manage:sow_write_access': 'wevo_access_api:manage:sow_write_access',
        'manage:ledger': 'wevo_access_api:manage:ledger',
        'manage:pricing': 'wevo_access_api:manage:pricing',
        'read:pricing': 'wevo_access_api:read:pricing',
        'manage:company_usage': 'wevo_access_api:manage:company_usage',
        'manage:seat_assignments': 'wevo_access_api:manage:seat_assignments',
        'manage:company_users': 'wevo_access_api:manage:company_users',
        'manage:sso': 'wevo_access_api:manage:sso',
    },
    CUSTOMER_API: {
        'submit:study_draft_for_approval': 'customer_api:submit:study_draft_for_approval',
        'submit:study_draft_self_approved': 'customer_api:submit:study_draft_self_approved',
        'approve:study_draft': 'customer_api:approve:study_draft',
        'access:personas': 'customer_api:access:personas',
        'access:navigation': 'customer_api:access:navigation',
        'access:pulse3.0': 'customer_api:access:pulse3.0',
        'access:figma': 'customer_api:access:figma',
        'access:figmaPublicImport': 'customer_api:access:figmaPublicImport',
        'access:figmaAuthenticated': 'customer_api:access:figmaAuthenticated',
        'access:figmaAuthenticatedV2': 'customer_api:access:figmaAuthenticatedV2',
        'access:figmaAuthenticatedImport': 'customer_api:access:figmaAuthenticatedImport',
        'access:figmaNavigation': 'customer_api:access:figmaNavigation',
        'access:figmaAgentNavigation': 'customer_api:access:figmaAgentNavigation',
        'access:compare': 'customer_api:access:compare',
        'access:compareNew': 'customer_api:access:compareNew',
        'access:comparePersonaLens': 'customer_api:access:comparePersonaLens',
        'access:context': 'customer_api:access:context',
        'access:search': 'customer_api:access:search',
        live_credit_tracking: 'customer_api:live_credit_tracking',
    },
    ARTEMIS_API: {},
    WEVO_PERSONA_API: {
        'canAccess:Navigation': 'wevo_persona_api:canAccess:Navigation',
        'access:navigation': 'wevo_persona_api:access:navigation',
        'canAccess:Figma': 'wevo_persona_api:canAccess:Figma',
        'canAccess:figmaPublicImport': 'wevo_persona_api:canAccess:figmaPublicImport',
        'canAccess:figmaAuthenticated': 'wevo_persona_api:canAccess:figmaAuthenticated',
        'canAccess:figmaAuthenticatedImport': 'wevo_persona_api:canAccess:figmaAuthenticatedImport',
        'canAccess:FigmaNavigation': 'wevo_persona_api:canAccess:FigmaNavigation',
        'canAccess:figmaAgentNavigation': 'wevo_persona_api:canAccess:figmaAgentNavigation',
        'canAccess:Compare': 'wevo_persona_api:canAccess:Compare',
        'canAccess:compareNew': 'wevo_persona_api:canAccess:compareNew',
        'canAccess:comparePersonaLens': 'wevo_persona_api:canAccess:comparePersonaLens',
        'canAccess:Context': 'wevo_persona_api:canAccess:Context',
        'canAccess:Search': 'wevo_persona_api:canAccess:Search',
        'canAccess:Assets': 'wevo_persona_api:canAccess:Assets',
        'canAccess:Interviews': 'wevo_persona_api:canAccess:Interviews',
        'canAccess:Audiences': 'wevo_persona_api:canAccess:Audiences',
        'canAccess:Screeners': 'wevo_persona_api:canAccess:Screeners',
        'canAccess:Pulse': 'wevo_persona_api:canAccess:Pulse',
        'canAccess:DevTools': 'wevo_persona_api:canAccess:DevTools',
        'canAccess:LegacyView': 'wevo_persona_api:canAccess:LegacyView',
        'canAccess:Explore': 'wevo_persona_api:canAccess:Explore',
        'canAccess:Capture': 'wevo_persona_api:canAccess:Capture',
        'canAccess:MockPages': 'wevo_persona_api:canAccess:MockPages',
        'canAccess:Personality': 'wevo_persona_api:canAccess:Personality',
        'canAccess:ResearchProfile': 'wevo_persona_api:canAccess:ResearchProfile',
        'canAccess:ResearchProfilePlus': 'wevo_persona_api:canAccess:ResearchProfilePlus',
        'canAccess:ResearchStudio': 'wevo_persona_api:canAccess:ResearchStudio',
    },
};
/**
 * Hierarchical permission enum for autocomplete support
 * Use dot notation to access permission IDs: P.CUSTOMER.API.APPROVE_STUDIES
 * Values are permission IDs (e.g., 'approve:studies') for direct scope comparison
 */
export const P = {
    WEVO: {
        ACCESS: {
            API: {
                ADMINISTRATE_ORGANIZATIONS: 'administrate:organizations',
                ADMINISTRATE_USERS: 'administrate:users',
                READ_USERS: 'read:users',
                MANAGE_USERS: 'manage:users',
                MANAGE_TEAMS: 'manage:teams',
                MANAGE_TEAM_MEMBERS: 'manage:team_members',
                EXECUTE_SYNC_OPERATIONS: 'execute:sync_operations',
                MANAGE_SOWS: 'manage:sows',
                READ_SOWS: 'read:sows',
                MANAGE_SOW_WRITE_ACCESS: 'manage:sow_write_access',
                MANAGE_LEDGER: 'manage:ledger',
                MANAGE_PRICING: 'manage:pricing',
                READ_PRICING: 'read:pricing',
                MANAGE_COMPANY_USAGE: 'manage:company_usage',
                MANAGE_SEAT_ASSIGNMENTS: 'manage:seat_assignments',
                MANAGE_COMPANY_USERS: 'manage:company_users',
                MANAGE_SSO: 'manage:sso',
            },
        },
        PERSONA: {
            API: {
                CANACCESS_NAVIGATION: 'canAccess:Navigation',
                ACCESS_NAVIGATION: 'access:navigation',
                CANACCESS_FIGMA: 'canAccess:Figma',
                CANACCESS_FIGMAPUBLICIMPORT: 'canAccess:figmaPublicImport',
                CANACCESS_FIGMAAUTHENTICATED: 'canAccess:figmaAuthenticated',
                CANACCESS_FIGMAAUTHENTICATEDIMPORT: 'canAccess:figmaAuthenticatedImport',
                CANACCESS_FIGMANAVIGATION: 'canAccess:FigmaNavigation',
                CANACCESS_FIGMAAGENTNAVIGATION: 'canAccess:figmaAgentNavigation',
                CANACCESS_COMPARE: 'canAccess:Compare',
                CANACCESS_COMPARENEW: 'canAccess:compareNew',
                CANACCESS_COMPAREPERSONALENS: 'canAccess:comparePersonaLens',
                CANACCESS_CONTEXT: 'canAccess:Context',
                CANACCESS_SEARCH: 'canAccess:Search',
                CANACCESS_ASSETS: 'canAccess:Assets',
                CANACCESS_INTERVIEWS: 'canAccess:Interviews',
                CANACCESS_AUDIENCES: 'canAccess:Audiences',
                CANACCESS_SCREENERS: 'canAccess:Screeners',
                CANACCESS_PULSE: 'canAccess:Pulse',
                CANACCESS_DEVTOOLS: 'canAccess:DevTools',
                CANACCESS_LEGACYVIEW: 'canAccess:LegacyView',
                CANACCESS_EXPLORE: 'canAccess:Explore',
                CANACCESS_CAPTURE: 'canAccess:Capture',
                CANACCESS_MOCKPAGES: 'canAccess:MockPages',
                CANACCESS_PERSONALITY: 'canAccess:Personality',
                CANACCESS_RESEARCHPROFILE: 'canAccess:ResearchProfile',
                CANACCESS_RESEARCHPROFILEPLUS: 'canAccess:ResearchProfilePlus',
                CANACCESS_RESEARCHSTUDIO: 'canAccess:ResearchStudio',
            },
        },
    },
    CUSTOMER: {
        API: {
            SUBMIT_STUDY_DRAFT_FOR_APPROVAL: 'submit:study_draft_for_approval',
            SUBMIT_STUDY_DRAFT_SELF_APPROVED: 'submit:study_draft_self_approved',
            APPROVE_STUDY_DRAFT: 'approve:study_draft',
            ACCESS_PERSONAS: 'access:personas',
            ACCESS_NAVIGATION: 'access:navigation',
            ACCESS_PULSE3_0: 'access:pulse3.0',
            ACCESS_FIGMA: 'access:figma',
            ACCESS_FIGMAPUBLICIMPORT: 'access:figmaPublicImport',
            ACCESS_FIGMAAUTHENTICATED: 'access:figmaAuthenticated',
            ACCESS_FIGMAAUTHENTICATEDV2: 'access:figmaAuthenticatedV2',
            ACCESS_FIGMAAUTHENTICATEDIMPORT: 'access:figmaAuthenticatedImport',
            ACCESS_FIGMANAVIGATION: 'access:figmaNavigation',
            ACCESS_FIGMAAGENTNAVIGATION: 'access:figmaAgentNavigation',
            ACCESS_COMPARE: 'access:compare',
            ACCESS_COMPARENEW: 'access:compareNew',
            ACCESS_COMPAREPERSONALENS: 'access:comparePersonaLens',
            ACCESS_CONTEXT: 'access:context',
            ACCESS_SEARCH: 'access:search',
            LIVE_CREDIT_TRACKING: 'live_credit_tracking',
        },
    },
};
/**
 * Permission metadata including descriptions and role assignments
 */
export const PERMISSION_METADATA = {
    wevo_access_api: {
        identifier: 'https://${var.api_url}/api',
        name: 'Wevo Access API - ${var.environment}',
        description: 'Wevo Access API for user and access management',
        permissions: [
            {
                id: 'administrate:organizations',
                description: 'Administrative access to organization data and management',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'wevo_access_api:administrate:organizations',
            },
            {
                id: 'administrate:users',
                description: 'Administrative access to user data and management',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'wevo_access_api:administrate:users',
            },
            {
                id: 'read:users',
                description: 'Read user data from the management database',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:read:users',
            },
            {
                id: 'manage:users',
                description: 'Manage users in the management database',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:users',
            },
            {
                id: 'manage:teams',
                description: 'Create and manage teams within the logged in organization',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:teams',
            },
            {
                id: 'manage:team_members',
                description: 'Manage team members within assigned teams',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:team_members',
            },
            {
                id: 'execute:sync_operations',
                description: 'Execute sync operations',
                roles: [{ name: 'developer', isUserFacing: false }],
                fullId: 'wevo_access_api:execute:sync_operations',
            },
            {
                id: 'manage:sows',
                description: 'Create, update, archive, expire, and roll over SOW agreements',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'wevo_access_api:manage:sows',
            },
            {
                id: 'read:sows',
                description: 'Read SOW agreement details, balances, usage reports, and ledger history',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                    { name: 'pro_user', isUserFacing: true },
                    { name: 'pro_restricted', isUserFacing: true },
                    { name: 'pro_approver', isUserFacing: true },
                    { name: 'pulse_user', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:read:sows',
            },
            {
                id: 'manage:sow_write_access',
                description: 'Enable SOW write protection and manage the per-SOW user write allowlist',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:sow_write_access',
            },
            {
                id: 'manage:ledger',
                description: 'Create and manage ledger entries including grants, usage, adjustments, refunds, reservations, reassignments, and imports',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'wevo_access_api:manage:ledger',
            },
            {
                id: 'manage:pricing',
                description: 'Create, update, clone, and deactivate pricing configurations',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'wevo_access_api:manage:pricing',
            },
            {
                id: 'read:pricing',
                description: 'Read pricing configurations',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'wevo_access_api:read:pricing',
            },
            {
                id: 'manage:company_usage',
                description: 'Manage company usage and credit tracking settings',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:company_usage',
            },
            {
                id: 'manage:seat_assignments',
                description: 'Assign and unassign Pulse seats',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:seat_assignments',
            },
            {
                id: 'manage:company_users',
                description: 'Manage company users, invitations, teams, and roles',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:company_users',
            },
            {
                id: 'manage:sso',
                description: 'Manage company self-service SSO settings',
                roles: [
                    { name: 'system_admin', isUserFacing: false },
                    { name: 'organization_admin', isUserFacing: true },
                ],
                fullId: 'wevo_access_api:manage:sso',
            },
        ],
    },
    customer_api: {
        identifier: 'https://customer.api.localwevoconversion.com/',
        name: 'Customer API - ${var.environment}',
        description: 'Customer API for Local WEVO Conversion',
        permissions: [
            {
                id: 'submit:study_draft_for_approval',
                description: 'Submit study drafts for approval in the logged in organization',
                roles: [{ name: 'pro_restricted', isUserFacing: true }],
                fullId: 'customer_api:submit:study_draft_for_approval',
            },
            {
                id: 'submit:study_draft_self_approved',
                description: 'Submit study drafts for approval in the logged in organization',
                roles: [
                    { name: 'pro_approver', isUserFacing: true },
                    { name: 'pro_user', isUserFacing: true },
                ],
                fullId: 'customer_api:submit:study_draft_self_approved',
            },
            {
                id: 'approve:study_draft',
                description: 'Approve submitted study drafts in the logged in organization',
                roles: [{ name: 'pro_approver', isUserFacing: true }],
                fullId: 'customer_api:approve:study_draft',
            },
            {
                id: 'access:personas',
                description: 'Access personas features in the logged in organization',
                roles: [{ name: 'pulse_user', isUserFacing: true }],
                fullId: 'customer_api:access:personas',
            },
            {
                id: 'access:navigation',
                description: 'Access Agent Navigation in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:navigation',
            },
            {
                id: 'access:pulse3.0',
                description: 'Create and run new Pulses natively in WEVO Pulse',
                roles: [],
                fullId: 'customer_api:access:pulse3.0',
            },
            {
                id: 'access:figma',
                description: 'Import publicly accessible Figma prototype links without Figma sign-in in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:figma',
            },
            {
                id: 'access:figmaPublicImport',
                description: 'DEPRECATED: use access:figma; retained for migration metadata only, not a feature grant',
                roles: [],
                fullId: 'customer_api:access:figmaPublicImport',
            },
            {
                id: 'access:figmaAuthenticated',
                description: 'Connect a Figma account with OAuth and import Figma prototypes that require Figma authentication in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:figmaAuthenticated',
            },
            {
                id: 'access:figmaAuthenticatedV2',
                description: 'Show authenticated Figma import in compatible Customer UI versions; backend OAuth authority still requires canAccess:figmaAuthenticated on the Persona API',
                roles: [],
                fullId: 'customer_api:access:figmaAuthenticatedV2',
            },
            {
                id: 'access:figmaAuthenticatedImport',
                description: 'DEPRECATED: use access:figmaAuthenticated; retained for migration metadata only, not a feature grant',
                roles: [],
                fullId: 'customer_api:access:figmaAuthenticatedImport',
            },
            {
                id: 'access:figmaNavigation',
                description: 'Let Goal Navigation navigate Figma prototypes; effective only with access:navigation and a Figma import permission',
                roles: [],
                fullId: 'customer_api:access:figmaNavigation',
            },
            {
                id: 'access:figmaAgentNavigation',
                description: 'DEPRECATED: use access:figmaNavigation; retained for migration metadata only, not a feature grant',
                roles: [],
                fullId: 'customer_api:access:figmaAgentNavigation',
            },
            {
                id: 'access:compare',
                description: 'Access the Compare 2.0 experience in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:compare',
            },
            {
                id: 'access:compareNew',
                description: 'Compare against a newly launched Pulse in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:compareNew',
            },
            {
                id: 'access:comparePersonaLens',
                description: 'Access Persona selection, Persona tasks, and Compare Lens results; effective only with access:compare',
                roles: [],
                fullId: 'customer_api:access:comparePersonaLens',
            },
            {
                id: 'access:context',
                description: 'Add and manage goal context files in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:context',
            },
            {
                id: 'access:search',
                description: 'Access global Pulse search in the logged in organization',
                roles: [],
                fullId: 'customer_api:access:search',
            },
            {
                id: 'live_credit_tracking',
                description: 'Access the live credit tracking Agreements & Usage experience',
                roles: [{ name: 'system_admin', isUserFacing: false }],
                fullId: 'customer_api:live_credit_tracking',
            },
        ],
    },
    artemis_api: {
        identifier: '${local.artemis_api_id}',
        name: 'Artemis API - ${var.environment}',
        description: 'Artemis API for advanced analytics and insights',
        permissions: [],
    },
    wevo_persona_api: {
        identifier: 'wevo-persona-api',
        name: 'wevo-persona-api',
        description: 'WEVO Persona API for Pulse sandbox access',
        permissions: [
            {
                id: 'canAccess:Navigation',
                description: 'Can access Agent Navigation',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Navigation',
            },
            {
                id: 'access:navigation',
                description: 'DEPRECATED: use canAccess:Navigation for Pulse Sandbox access',
                roles: [],
                fullId: 'wevo_persona_api:access:navigation',
            },
            {
                id: 'canAccess:Figma',
                description: 'Import publicly accessible Figma prototype links without Figma sign-in.',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Figma',
            },
            {
                id: 'canAccess:figmaPublicImport',
                description: 'DEPRECATED: use canAccess:Figma; retained for migration metadata only, not a feature grant',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:figmaPublicImport',
            },
            {
                id: 'canAccess:figmaAuthenticated',
                description: 'Connect a Figma account with OAuth and import prototypes that require Figma authentication.',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:figmaAuthenticated',
            },
            {
                id: 'canAccess:figmaAuthenticatedImport',
                description: 'DEPRECATED: use canAccess:figmaAuthenticated; retained for migration metadata only, not a feature grant',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:figmaAuthenticatedImport',
            },
            {
                id: 'canAccess:FigmaNavigation',
                description: 'Goal Navigation of Figma prototypes; effective only with canAccess:Navigation and a Figma import permission.',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:FigmaNavigation',
            },
            {
                id: 'canAccess:figmaAgentNavigation',
                description: 'DEPRECATED: use canAccess:FigmaNavigation; retained for migration metadata only, not a feature grant',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:figmaAgentNavigation',
            },
            {
                id: 'canAccess:Compare',
                description: 'Can access the native Compare 2.0 experience',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Compare',
            },
            {
                id: 'canAccess:compareNew',
                description: 'Can compare against a newly launched Pulse',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:compareNew',
            },
            {
                id: 'canAccess:comparePersonaLens',
                description: 'Persona selection, Persona tasks, and Compare Lens results; effective only with canAccess:Compare',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:comparePersonaLens',
            },
            {
                id: 'canAccess:Context',
                description: 'Can add and manage goal context files',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Context',
            },
            {
                id: 'canAccess:Search',
                description: 'Can access global Pulse search',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Search',
            },
            {
                id: 'canAccess:Assets',
                description: 'Can access assets',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Assets',
            },
            {
                id: 'canAccess:Interviews',
                description: 'Can access interviews',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Interviews',
            },
            {
                id: 'canAccess:Audiences',
                description: 'Can access audiences',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Audiences',
            },
            {
                id: 'canAccess:Screeners',
                description: 'Can access screeners',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Screeners',
            },
            {
                id: 'canAccess:Pulse',
                description: 'Can access pulse',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Pulse',
            },
            {
                id: 'canAccess:DevTools',
                description: 'Can access dev tools',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:DevTools',
            },
            {
                id: 'canAccess:LegacyView',
                description: 'Can access legacy view',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:LegacyView',
            },
            {
                id: 'canAccess:Explore',
                description: 'Can access explore',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Explore',
            },
            {
                id: 'canAccess:Capture',
                description: 'Can access capture',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Capture',
            },
            {
                id: 'canAccess:MockPages',
                description: 'Can access mock pages',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:MockPages',
            },
            {
                id: 'canAccess:Personality',
                description: 'Can access personality',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:Personality',
            },
            {
                id: 'canAccess:ResearchProfile',
                description: 'Can access research profile',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:ResearchProfile',
            },
            {
                id: 'canAccess:ResearchProfilePlus',
                description: 'Can access research profile plus',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:ResearchProfilePlus',
            },
            {
                id: 'canAccess:ResearchStudio',
                description: 'Can access research studio',
                roles: [],
                fullId: 'wevo_persona_api:canAccess:ResearchStudio',
            },
        ],
    },
};
/**
 * Type guard to check if a string is a valid permission
 */
export const isValidPermission = (permission) => {
    return Object.values(PERMISSIONS).some((serverPerms) => Object.values(serverPerms).includes(permission));
};
/**
 * Role metadata including descriptions and assigned permissions
 */
export const ROLE_METADATA = {
    organization_admin: {
        name: 'organization_admin',
        description: 'Administrator role with full access to the logged in organization',
        isUserFacing: true,
        permissions: [
            'wevo_access_api:read:users',
            'wevo_access_api:manage:users',
            'wevo_access_api:manage:teams',
            'wevo_access_api:manage:team_members',
            'wevo_access_api:read:sows',
            'wevo_access_api:manage:sow_write_access',
            'wevo_access_api:manage:company_usage',
            'wevo_access_api:manage:seat_assignments',
            'wevo_access_api:manage:company_users',
            'wevo_access_api:manage:sso',
        ],
    },
    pro_approver: {
        name: 'pro_approver',
        description: 'Elevated PRO user with access to the logged in organization, and the ability to approve submitted studies',
        isUserFacing: true,
        permissions: [
            'wevo_access_api:read:sows',
            'customer_api:submit:study_draft_self_approved',
            'customer_api:approve:study_draft',
        ],
    },
    pro_restricted: {
        name: 'pro_restricted',
        description: 'Restricted PRO user with basic access to the logged in organization, and the ability to submit studies for approval',
        isUserFacing: true,
        permissions: [
            'wevo_access_api:read:sows',
            'customer_api:submit:study_draft_for_approval',
        ],
    },
    pro_user: {
        name: 'pro_user',
        description: 'Standard PRO user with basic access to the logged in organization',
        isUserFacing: true,
        permissions: [
            'wevo_access_api:read:sows',
            'customer_api:submit:study_draft_self_approved',
        ],
    },
    pulse_user: {
        name: 'pulse_user',
        description: 'Standard Pulse user with basic access to the logged in organization',
        isUserFacing: true,
        permissions: [
            'wevo_access_api:read:sows',
            'customer_api:access:personas',
        ],
    },
    system_admin: {
        name: 'system_admin',
        description: 'Super administrator with cross-organization access (can manage all organizations, limited to WEVO employees)',
        isUserFacing: false,
        permissions: [
            'wevo_access_api:administrate:organizations',
            'wevo_access_api:administrate:users',
            'wevo_access_api:read:users',
            'wevo_access_api:manage:users',
            'wevo_access_api:manage:teams',
            'wevo_access_api:manage:team_members',
            'wevo_access_api:manage:sows',
            'wevo_access_api:read:sows',
            'wevo_access_api:manage:sow_write_access',
            'wevo_access_api:manage:ledger',
            'wevo_access_api:manage:pricing',
            'wevo_access_api:read:pricing',
            'wevo_access_api:manage:company_usage',
            'wevo_access_api:manage:seat_assignments',
            'wevo_access_api:manage:company_users',
            'wevo_access_api:manage:sso',
            'customer_api:live_credit_tracking',
        ],
    },
    developer: {
        name: 'developer',
        description: 'Use with access to development tools and resources',
        isUserFacing: false,
        permissions: ['wevo_access_api:execute:sync_operations'],
    },
    navigation_user: {
        name: 'navigation_user',
        description: 'Agent Navigation in the Customer application and Pulse API',
        isUserFacing: true,
        permissions: [],
    },
    persona_sharing_user: {
        name: 'persona_sharing_user',
        description: 'Persona sharing in the Customer application and Pulse API',
        isUserFacing: true,
        permissions: [],
    },
    download_powerpoint_user: {
        name: 'download_powerpoint_user',
        description: 'PowerPoint presentation downloads in the Customer application and Pulse API',
        isUserFacing: true,
        permissions: [],
    },
    agent_intake_user: {
        name: 'agent_intake_user',
        description: 'Conversational Agent Intake setup in the Pulse API',
        isUserFacing: true,
        permissions: [],
    },
    search_user: {
        name: 'search_user',
        description: 'Global Pulse search in the Customer application and Pulse API',
        isUserFacing: true,
        permissions: [],
    },
    pulse3_mvp_user: {
        name: 'pulse3_mvp_user',
        description: 'Pulse 3.0 release bundle (features staged before they reach pulse_user) for WEVO employees and selected customers',
        isUserFacing: true,
        permissions: [],
    },
    pulse_upload_proxy_user: {
        name: 'pulse_upload_proxy_user',
        description: 'Routes Pulse file uploads through the Customer API host for networks that only allow allowlisted upload hosts',
        isUserFacing: true,
        permissions: [],
    },
};
/**
 * Get all permissions assigned to a role
 */
export const getRolePermissions = (role) => {
    return [...(ROLE_METADATA[role]?.permissions || [])];
};
//# sourceMappingURL=permissions.js.map